// main.js サイトで利用するスクリプトを記載
// ./core/ jQuery本体（異なるバージョンを利用したい場合はcore内のライブラリを差し替えてください）
// ./app/ 各種プラグイン各種を格納

// ここからは自由に

//スムーススクロール
/* eslint-disable */
var scroll = new SmoothScroll('a[href*="#"].js_smooth');
/* eslint-enable */

// TOPへ戻るボタン
var pagetop = $('.pagetop');
$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    pagetop.fadeIn();
  } else {
    pagetop.fadeOut();
  }
});
pagetop.click(function () {
  $('body, html').animate({ scrollTop: 0 }, 500);
  return false;
});

//menu
$(function(){
  $(".bl_header_hamburger").click(function () {
    $(this).toggleClass("is_open");
     $("nav").fadeToggle(100).css('display', 'flex');
  });
  $(".ly_nav .js_anchor").click(function () {
    $(".bl_header_hamburger").removeClass("is_open");
     $("nav").fadeOut(100).css('display', 'flex');
  });
});


//close btn
var btn_close = $('.bl_pageClose');
$(window).scroll(function () {
  if ($(this).scrollTop() > 170) {
    btn_close.addClass("is_scroll");
  } else {
    btn_close.removeClass("is_scroll");
  }
});

//object fit
objectFitImages();
